import React from 'react';

function StatePassive() {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 9.26758C0 4.29702 4.02944 0.267578 9 0.267578C13.9706 0.267578 18 4.29702 18 9.26758C18 14.2381 13.9706 18.2676 9 18.2676C4.02944 18.2676 0 14.2381 0 9.26758Z"
        fill="#E0F1F3"
      />
      <path
        d="M11.625 8.61133H9.65625V6.64258C9.65625 6.401 9.46033 6.20508 9.21875 6.20508H8.78125C8.53967 6.20508 8.34375 6.401 8.34375 6.64258V8.61133H6.375C6.13342 8.61133 5.9375 8.80725 5.9375 9.04883V9.48633C5.9375 9.72791 6.13342 9.92383 6.375 9.92383H8.34375V11.8926C8.34375 12.1342 8.53967 12.3301 8.78125 12.3301H9.21875C9.46033 12.3301 9.65625 12.1342 9.65625 11.8926V9.92383H11.625C11.8666 9.92383 12.0625 9.72791 12.0625 9.48633V9.04883C12.0625 8.80725 11.8666 8.61133 11.625 8.61133Z"
        fill="#0A8EA0"
      />
    </svg>
  );
}

export default StatePassive;
